if (!customElements.get('mobile-menu')) {
  customElements.define(
    'mobile-menu',
    class MobileMenu extends HTMLElement {
      constructor() {
        super();
        this.openSubmenuButtons = this.querySelectorAll('[data-open-submenu]');
        this.submenus = this.querySelectorAll('[data-submenu]');
        this.closeSumbmenuButtons = this.querySelectorAll('[data-close-submenu]');
        this.openChildmenuButtons = this.querySelectorAll('[data-open-childmenu]');
        this.childmenus = this.querySelectorAll('[data-childmenu]');
        this.closeChildmenuButtons = this.querySelectorAll('[data-close-childmenu]');
      }

      connectedCallback() {
        this.handleSubmenus();
        this.handleChildMenus();
      }

      handleSubmenus() {
        if (this.openSubmenuButtons.length === 0) return;
        this.openSubmenuButtons.forEach((button) => {
          button.addEventListener('click', () => {
            const submenuHandle = button.dataset?.openSubmenu;
            const submenu = this.querySelector(`[data-submenu="${submenuHandle}"]`);
            if (!submenu) return;
            submenu.classList.add('active');
          });
        });

        if (this.closeSumbmenuButtons.length === 0 || this.submenus.length === 0) return;
        this.closeSumbmenuButtons.forEach((button) => {
          button.addEventListener('click', () =>
            this.submenus.forEach((submenu) => submenu.classList.remove('active'))
          );
        });
      }

      handleChildMenus() {
        if (this.openChildmenuButtons.length === 0) return;
        this.openChildmenuButtons.forEach((button) => {
          button.addEventListener('click', () => {
            const childmenuHandle = button.dataset?.openChildmenu;
            const childmenu = this.querySelector(`[data-childmenu="${childmenuHandle}"]`);
            if (!childmenu) return;
            childmenu.classList.add('active');
          });
        });

        if (this.closeChildmenuButtons.length === 0 || this.childmenus.length === 0) return;
        this.closeChildmenuButtons.forEach((button) => {
          button.addEventListener('click', () => {
            this.childmenus.forEach((childmenu) => childmenu.classList.remove('active'));
          });
        });
      }
    }
  );
}
